import React from "react";
import styles from "./WellbeingFoundations.module.scss";
import { useHistory } from "react-router-dom";
import TitleCard from "../cards/TitleCard";
import MainCard from "../cards/MainCard";
import Icon from "../icons/Icon";

import WellbeingFoundationCard from "../assets/wellbeingfoundationcard.svg?url";
import ImageStudentIntroduction from "../assets/student-introduction.png";
import ImageBrainBreak from "../assets/brainbreakimage.png";
import ImageSkillBuilder from "../assets/skillBuilder.png";

import {
  IconStudentIntroduction,
  IconWellbeingFoundation,
  IconSkillBuilder,
  IconWellbeingFoundations,
} from "@src/constants";

type Props = {
  isAUuser?: boolean;
}

function WellBeingFoundationsSection(props: Props) {
  const { isAUuser } = props;
  const history = useHistory();
  const openCard = (tab) => {
    history.replace(`/wellbeingfoundations?tab=${tab}`)
  }

  return (
    <>
        <TitleCard
          title={isAUuser ? "Wellbeing Foundations" : "Well-Being Foundations"}
          detail="Lessons for Getting Started; Icebreaker Exercises; and Skill-Building Activities"
          leftIcon={<Icon src={IconWellbeingFoundation} isTitle={true} />}
        />
        <div className={styles.cardView}>
          <MainCard
            titleLine1="Student"
            titleLine2="Introduction"
            backGroundUrl={WellbeingFoundationCard}
            imageUrl={ImageStudentIntroduction}
            openCard={() => openCard("student-introduction")}
            mainIcon={<Icon src={IconStudentIntroduction} />}
            hoverTitle="Start here when first introducing Open Parachute to your class."
            hoverHint="Run a few Brain Breaks prior to introducing the lessons to help your class feel more comfortable to dive deeper into the lessons!"
          />
          <MainCard
            titleLine1="Brain"
            titleLine2="Breaks"
            backGroundUrl={WellbeingFoundationCard}
            imageUrl={ImageBrainBreak}
            openCard={() => openCard("brainbreaks")}
            mainIcon={<Icon src={IconWellbeingFoundations} />}
            hoverTitle="Use the Brain Breaks to ensure all your students know one another and are comfortable with each other."
            hoverHint="If your class is not engaging in the lessons, run some brain breaks to help increase trust amongst your students."
          />
          <MainCard
            titleLine1="Skill"
            titleLine2="Builders"
            backGroundUrl={WellbeingFoundationCard}
            imageUrl={ImageSkillBuilder}
            openCard={() => openCard("skillbuilders")}
            mainIcon={<Icon src={IconSkillBuilder} />}
            hoverTitle="Short, approachable/practical lessons intended to practice well-being strategies anytime in any course. These will build on skills that students have already practiced as well as provide the opportunity to learn and practice new skills."
          />
        </div>
      </>
  );
}

export default WellBeingFoundationsSection;
